
// This file loads polyfills to handle issues with Node.js builtins in the browser
import { Buffer } from 'buffer';
import process from 'process/browser';

// Make Buffer available globally
window.Buffer = window.Buffer || Buffer;

// Make process available globally
window.process = process;

// Add any other necessary polyfills here
console.log('Polyfills initialized successfully');
